import { render } from "./PropertyTypeData.vue?vue&type=template&id=5f707682&scoped=true"
import script from "./PropertyTypeData.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyTypeData.vue?vue&type=script&setup=true&lang=js"

import "./PropertyTypeData.vue?vue&type=style&index=0&id=5f707682&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f707682"],['__file',"src/pages/property/PropertyTypeData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f707682"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f707682', __exports__)) {
    console.log('reload')
    api.reload('5f707682', __exports__)
  }
  
  module.hot.accept("./PropertyTypeData.vue?vue&type=template&id=5f707682&scoped=true", () => {
    console.log('re-render')
    api.rerender('5f707682', render)
  })

}


export default __exports__